import { useEffect } from "react";
import { Link } from "react-router-dom";
import {
  TIMELINE_META,
  TIMELINE_SESSIONS,
  TIMELINE_BUILD_DATE,
} from "../lib/timeline-loader";
import { MarkdownRenderer } from "../components/timeline/MarkdownRenderer";
import { TimelineSession } from "../components/timeline/TimelineSession";

export function Timeline() {
  useEffect(() => {
    const prev = document.title;
    document.title = `${TIMELINE_META.meta.title} — Timeline`;
    return () => {
      document.title = prev;
    };
  }, []);

  return (
    <div className="timeline-page -mx-6 md:-mx-0">
      <header className="timeline-sticky sticky top-0 z-10 border-b border-border/60 bg-bg/80 backdrop-blur-md px-6 py-3 md:px-0 print:static print:border-0 print:bg-transparent print:backdrop-blur-none">
        <p className="text-xs font-medium uppercase tracking-wider text-fg-muted">
          Workshop-Timeline
        </p>
        <p className="truncate text-sm font-medium text-fg">
          {TIMELINE_META.meta.title}
        </p>
      </header>

      <div className="space-y-12 px-6 pt-10 md:px-0">
        <header className="space-y-3">
          <p className="text-sm font-medium text-accent">
            8 Sessions · 90 Minuten je Session
          </p>
          <h1 className="text-3xl font-semibold tracking-tight md:text-4xl">
            {TIMELINE_META.meta.title}
          </h1>
          <p className="text-fg-muted leading-relaxed">
            {TIMELINE_META.meta.subtitle}
          </p>
          <div className="pt-2">
            <MarkdownRenderer>{TIMELINE_META.body}</MarkdownRenderer>
          </div>
        </header>

        <div className="timeline-track relative">
          <div
            aria-hidden
            className="timeline-line absolute left-3 top-2 bottom-2 w-px bg-border md:left-5"
          />
          <div className="space-y-2">
            {TIMELINE_SESSIONS.map((s) => (
              <TimelineSession key={s.slug} session={s} />
            ))}
          </div>
        </div>

        <footer className="border-t border-border pt-6 pb-12 text-xs text-fg-muted">
          <p>Stand: {TIMELINE_BUILD_DATE}</p>
          <p className="pt-2">
            <Link
              to="/"
              className="text-accent underline underline-offset-2 hover:opacity-80"
            >
              ← Zurück zum Start
            </Link>
          </p>
        </footer>
      </div>
    </div>
  );
}
